/**
 * Class that describes a control property
 */
export class DescriptorProperty {

    /**
     * The propoerty name
     */
    propertyName: string = '';

    /**
     * The propoerty value
     */
    propertyValue: any;
}